import { render, staticRenderFns } from "./PlanetData.vue?vue&type=template&id=53e38f58&"
import script from "./PlanetData.vue?vue&type=script&lang=js&"
export * from "./PlanetData.vue?vue&type=script&lang=js&"
import style0 from "./PlanetData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports